module.exports = __webpack_public_path__ + "img/brand.5039f961.svg";